import { useFormik } from 'formik'
import { FC } from 'react'
import { Button, FormInput, FormTextArea, useModal } from '../../../../../../components'
import { ButtonType, showAlert, showError } from '../../../../../../../_metronic/helpers'
import { formulaSchema } from '../../validation/formulaSchema'
import { updateFormula } from '../../core/_requests'
import { CustomOption, FormulaDtoCadastro } from '../../core/_model'
import { useT } from '_metronic/i18n/Metronici18n'

type IProps = {
  onConfirm: (item: CustomOption) => void
  item?: CustomOption
}

export const FormulaModal: FC<IProps> = ({ onConfirm, item }) => {
  const { closeModal } = useModal()
  const { t } = useT()
  const id = item?.value ? Number(item.value) : undefined
  const isPersisted = !!id

  const initialValues = {
    formula: item?.label || '',
    descricao: item?.descricao || '',
  }

  const formik = useFormik({
    initialValues,
    validationSchema: formulaSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        let result: CustomOption

        if (isPersisted && id) {
          const data: FormulaDtoCadastro = {
            nome: values.formula,
            descricao: values.descricao || undefined,
          }

          const updated = await updateFormula(id, data)

          result = {
            value: updated.id,
            label: updated.nome || values.formula,
            descricao: updated.descricao,
          }

          await showAlert({
            title: t('common.success'),
            text: t('alert.atualizar', {
              gender: t('formula.gender'),
              name: t('formula.label'),
            }),
            icon: 'success',
          })
        } else {
          result = {
            label: values.formula,
            descricao: values.descricao,
            value: null,
          }
        }

        onConfirm(result)
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <FormInput
        formik={formik}
        name='formula'
        placeholder='Digite o nome do fórmula'
        label='Fórmula'
        isRequired={true}
        className='mb-3'
      />
      <FormTextArea
        formik={formik}
        name='descricao'
        label='Composição'
        placeholder='Digite a composição da fórmula'
      />

      <div className='d-flex justify-content-end mt-5'>
        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {isPersisted ? t('common.save') : t('common.create')}
        </Button>
      </div>
    </form>
  )
}
